import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReusableTable from "../components/ReusableTable";
import { getApiUrl } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SizeChartPage = () => {
  const UserId = "66abc123def4567890abcd12";

  const [sizeCharts, setSizeCharts] = useState([]);
  const [sizes, setSizes] = useState([
    { size: "", bust: "", waist: "", hip: "", topLength: "", pantLength: "", thigh: "" }
  ]);
  const [editId, setEditId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const fetchSizeCharts = async () => {
    try {
      const res = await fetch(getApiUrl("getCharts"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userid: UserId })
      });

      const result = await res.json();
      if (result.success) {
        setSizeCharts(result.data);
      }
    } catch (error) {
      toast.error("Failed to fetch charts");
    }
  };

  useEffect(() => {
    fetchSizeCharts();
  }, []);

  const openAddModal = () => {
    setEditId(null);
    formik.resetForm();
    setSizes([{ size: "", bust: "", waist: "", hip: "", topLength: "", pantLength: "", thigh: "" }]);
    setShowModal(true);
  };

  const openEditModal = (chart) => {
    setEditId(chart._id);
    formik.setFieldValue("chartName", chart.chartName);
    setSizes(chart.sizes);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const res = await fetch(getApiUrl("sizechart-delete"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userid: UserId, chartid: id })
    });

    const result = await res.json();
    if (result.success) {
      toast.success("Deleted Successfully!");
      fetchSizeCharts();
    }
  };

  const formik = useFormik({
    initialValues: { chartName: "" },

    validationSchema: Yup.object({
      chartName: Yup.string().required("Chart name is required"),
    }),

    onSubmit: async (values) => {
      const payload = { ...values, userid: UserId, sizes };
      if (editId) payload.chartid = editId;

      const url = editId ? getApiUrl("sizechart-update") : getApiUrl("sizechart");

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const result = await res.json();
      if (result.success) {
        toast.success(editId ? "Updated Successfully!" : "Added Successfully!");
        setShowModal(false);
        fetchSizeCharts();
      } else {
        toast.error(result.message);
      }
    },
  });

  const handleSizeChange = (index, field, value) => {
    const updated = [...sizes];
    updated[index][field] = value;
    setSizes(updated);
  };

  const addRow = () => {
    setSizes([
      ...sizes,
      { size: "", bust: "", waist: "", hip: "", topLength: "", pantLength: "", thigh: "" },
    ]);
  };

  const removeRow = (index) => {
    setSizes(sizes.filter((_, i) => i !== index));
  };

  const columns = [
    { name: "Chart Name", selector: (row) => row.chartName },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <button className="btn btn-warning btn-sm me-2" onClick={() => openEditModal(row)}>
            <i className="fa-regular fa-pen-to-square"></i>
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => handleDelete(row._id)}>
            <i className="fa-regular fa-trash-can"></i>
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      <ToastContainer position="top-right" autoClose={5000} />

      <div className="d-flex justify-content-between mb-3">
        <h3 className="fw-bold">Size Chart Management</h3>
        <button className="btn btn-primary" onClick={openAddModal}>
          + Add Size Chart
        </button>
      </div>

      <ReusableTable columns={columns} data={sizeCharts} title="Size Chart List" />

      {showModal && (
        <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content rounded-4">
              <div className="modal-header">
                <h4 className="modal-title fw-bold">{editId ? "Edit Size Chart" : "Add Size Chart"}</h4>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>

              <form onSubmit={formik.handleSubmit}>
                <div className="modal-body">
                  <input
                    type="text"
                    name="chartName"
                    placeholder="Chart Name"
                    value={formik.values.chartName}
                    onChange={formik.handleChange}
                    className="form-control mb-3"
                  />

                  {sizes.map((row, index) => (
                    <div key={index} className="border rounded p-3 mb-2">
                      <div className="row g-2">
                        {Object.keys(row).map((field) => (
                          <div className="col" key={field}>
                            <input
                              type="text"
                              className="form-control"
                              placeholder={field}
                              value={row[field]}
                              onChange={(e) => handleSizeChange(index, field, e.target.value)}
                            />
                          </div>
                        ))}
                        <button type="button" className="btn btn-danger btn-sm mt-2" onClick={() => removeRow(index)}>
                          Delete Row
                        </button>
                      </div>
                    </div>
                  ))}

                  <button type="button" className="btn btn-secondary" onClick={addRow}>
                    + Add Size Row
                  </button>
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-light" onClick={() => setShowModal(false)}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-success">
                    {editId ? "Update" : "Save"}
                  </button>
                </div>
              </form>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SizeChartPage;
